import { render } from "./GlobalPartnersListSingle.vue?vue&type=template&id=2b8bb25a"
import script from "./GlobalPartnersListSingle.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersListSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__